import $ from 'jquery';

export default function sliderGroup() {
    var previous          = $().isWelshPage() ? 'Blaenorol' : 'Previous',
        next              = $().isWelshPage() ? 'Nesaf' : 'Next',
        responsiveOptions = [];

    $('.js-slick-slider-group-cards').each(function() {
        var $this = $(this);

        function hasBodyText() {
            return $this.parent().find('.slider-group-body-text').length > 0;
        }

        if (hasBodyText()) {
            responsiveOptions = [
                {
                    breakpoint: 579,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ];
        } else {
            responsiveOptions = [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ];
        }

        $this.slick({
            prevArrow: `<button class="slick-prev" aria-label="${previous}" type="button">${previous}</button>`,
            nextArrow: `<button class="slick-next" aria-label="${next}" type="button">${next}</button>`,
            dots: $this.find('.slider-group-cards-item').length < 6,
            speed: 100,
            infinite: false,
            mobileFirst: true,
            accessibility: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: responsiveOptions
        }).magnificPopup({
            type: 'iframe',
            delegate: 'a.video-popup:not(.slick-cloned)'
        });
    });
}
